// TrialExpired — friendly endpoint shown when the API returns 403 "trial has expired".
// We arrive here either via an axios interceptor redirect or a direct visit after the
// auto-logout that happens when the 24-hour window closes.
import { Link } from 'react-router-dom';
import { Sparkles, Clock, Mail } from 'lucide-react';
import { PanorixLogoCompact } from '@/components/PanorixLogo';

export default function TrialExpired() {
  return (
    <div className="min-h-screen bg-[#070B14] text-slate-100 flex flex-col" style={{ fontFamily: '"DM Sans","Inter",sans-serif' }}>
      <header className="border-b border-slate-800/60">
        <div className="max-w-[1200px] mx-auto px-8 h-16 flex items-center">
          <Link to="/"><PanorixLogoCompact size={140}/></Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-lg rounded-xl p-10 text-center" data-testid="trial-expired-card"
          style={{ background: 'rgba(11,18,32,0.7)', border: '1px solid rgba(242,107,31,0.35)' }}>
          <div className="inline-flex items-center gap-2 mb-4 px-3 py-1.5 rounded text-[10px] tracking-[0.25em] uppercase font-medium border"
            style={{ borderColor: '#F26B1F', color: '#F26B1F', background: 'rgba(242,107,31,0.08)' }}>
            <Clock className="w-3.5 h-3.5"/> Trial Window Closed
          </div>
          <h1 className="text-2xl font-light tracking-wide mb-2">
            Your <span style={{ color: '#F26B1F' }}>24-hour trial</span> has ended.
          </h1>
          <p className="text-sm text-slate-400 leading-relaxed mb-8">
            Thanks for taking Panorix for a spin. Your sandbox access has been revoked
            automatically — but your real journey can begin in minutes.
          </p>

          <div className="grid grid-cols-1 gap-3 text-left mb-8">
            <div className="flex items-start gap-3 p-4 rounded-lg" style={{ background: 'rgba(30,78,140,0.08)', border: '1px solid rgba(30,78,140,0.4)' }}>
              <Sparkles className="w-4 h-4 text-[#5790C9] mt-0.5"/>
              <div>
                <div className="text-sm text-slate-100 mb-0.5">Want to keep going?</div>
                <p className="text-xs text-slate-400">Talk to the Capexara team to spin up your own organization with real projects, real users, and full access.</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="mailto:hello@capexara.com?subject=Upgrade%20from%20Panorix%20Trial"
              className="inline-flex items-center gap-2 bg-[#1E4E8C] hover:bg-[#143A6B] text-white px-5 py-2.5 rounded text-[12px] tracking-[0.15em] uppercase transition" data-testid="trial-expired-contact">
              <Mail className="w-4 h-4"/> Contact Capexara
            </a>
            <Link to="/" className="text-[12px] tracking-[0.2em] uppercase text-slate-400 hover:text-white px-3 py-2 transition" data-testid="trial-expired-home">
              ← Back to home
            </Link>
          </div>
        </div>
      </main>

      <footer className="border-t border-slate-800/60 py-4">
        <div className="max-w-[1200px] mx-auto px-8 text-[10px] tracking-[0.3em] uppercase text-slate-600 text-center">
          Panorix · A Capexara platform
        </div>
      </footer>
    </div>
  );
}
